<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/system/cityArea.js";
export default {
  name: "cityArea",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ id: row.id });
              this.$page
                .handleRequestMethods(
                  data.id ? "update" : "add",
                  data,
                  true,
                  true
                )
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            title: this.$tz("新增"),
            modalBind: {
              width: 500,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              country_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              city_id: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "number",
                },
              ],
              title: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ country_id: 24 }, { city_id: 24 }, { title: 24 }],
          fields: [
            {
              name: () => this.$tz("国家"),
              key: "country_id",
              placeholder() {
                return this.$tz("国家");
              },
              component: "Select",
              config: {
                value: "id",
                label: "title",
              },
              options: [],
              optionsFn: "formCountry",
              optionsKey: "",
              methods: {
                "on-change"({ value, field, fields, formData }) {
                  let country_code = field.options.find(
                    (item) => item.id == value
                  ).code;
                  formData.city_id = "";

                  if (value) {
                    this.$page
                      .handleRequestMethods("city", {
                        country_code,
                      })
                      .then((res) => {
                        fields.find((item) => item.key == "city_id").options =
                          res.payload.rows.map((item) => ({
                            value: item.id,
                            label: item.title,
                          }));
                      });
                  } else {
                    fields.find((item) => item.key == "city_id").options = [];
                  }
                },
              },
            },
            {
              name: () => this.$tz("城市"),
              key: "city_id",
              placeholder() {
                return this.$tz("城市");
              },
              component: "Select",
              options: [],
              optionsFn: "",
              optionsKey: "",
            },
            {
              name: () => this.$tz("区域"),
              key: "title",
              component: "Input",
              placeholder: () => this.$tz("区域"),
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("新增"),
              type: "add",
              fnName: "add",
              bind: {
                type: "primary",
              },
            },
          ],
          methods: {
            add() {
              this.getModal("add").open({}, function () {
                this.setTitle(this.$tz("新增"));
              });
            },
          },
        },
      },
      fields: [
        {
          name: () => this.$t("country_t"),
          key: "country_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("province"),
          key: "city_province",
          minWidth: 130,
        },
        {
          name: () => this.$t("city_t"),
          key: "city_name",
          minWidth: 130,
        },
        {
          name: () => this.$tz("城市别名"),
          key: "city_source_title",
          minWidth: 130,
        },
        {
          name: () => this.$t("Area"),
          key: "title",
          minWidth: 130,
        },
        {
          name: () => this.$t("city_code"),
          key: "city_code",
          minWidth: 130,
        },
        {
          name: () => this.$tz("城市线路"),
          key: "city_circuit",
          minWidth: 130,
        },
        {
          name: () => this.$t("zip_code"),
          key: "zipcode",
          minWidth: 130,
        },
        {
          name: () => this.$t("SupportCod"),
          key: "is_cod",
          minWidth: 130,
          methods: {
            render({ row }) {
              return row.is_cod == 1 ? this.$tz("是") : this.$t("否");
            },
          },
        },
        {
          name: () => this.$t("remote_regions"),
          key: "remote_regions",
          minWidth: 130,
          methods: {
            render({ row }) {
              return row.remote_regions == 1 ? this.$tz("是") : this.$t("否");
            },
          },
        },
        {
          name: () => this.$t("tip"),
          key: "status",
          minWidth: 130,
        },
        {
          name: () => this.$t("financialZoning"),
          key: "division",
          minWidth: 130,
        },
        {
          name: () => this.$t("addTime"),
          key: "create_tme",
          minWidth: 130,
        },
        {
          name: () => this.$t("createName"),
          key: "operator_name",
          minWidth: 130,
        },
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          minWidth: 130,
        },
        {
          name: () => this.$t("operation"),
          type: "btns",
          width: 220,
          fixed: "right",
          list: [
            {
              name: this.$tz("更新"),
              type: "update",
              fnName: "update",
              bind: {
                type: "primary",
              },
              id: "",
            },
            {
              name: () => this.$tz("删除"),
              type: "del",
              fnName: "del",
              bind: {
                type: "error",
              },
            },
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("detail", { id: row.id }).then(
                (res) => {
                  this.getModal("add").open(res.payload, function () {
                    this.setTitle(this.$tz("更新"));
                  });
                }
              );
            },
            del({ row }) {
              this.$Modal.confirm({
                title: this.$tz("删除"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "del",
                    { id: row.id },
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>